import React from "react";
import { IonChip, IonLabel } from "@ionic/react";
import { ICart } from "../../../models";

/** Reservation (PreAuth) is guaranteed by the bank for 7 days: capture before it runs out. */
const HOLD_DAYS = 7;
const WARN_FROM_DAY = 5;

export const daysSinceAuthorization = (cart: ICart): number | null => {
  const at = cart.payment?.authorizedAt;
  if (!at) return null;
  const ms = Date.now() - new Date(at).getTime();
  return Math.floor(ms / (24 * 60 * 60 * 1000));
};

const LABELS: { [status: string]: { text: string; color: string } } = {
  PENDING: { text: "čeka plaćanje", color: "medium" },
  FAILED: { text: "neuspešno plaćanje", color: "danger" },
  AUTHORIZED: { text: "rezervisano, naplatiti", color: "warning" },
  CAPTURED: { text: "naplaćeno", color: "success" },
  VOIDED: { text: "poništeno", color: "medium" },
  REFUNDED: { text: "refundirano", color: "medium" },
};

/** Card orders only: payment status, and how long the bank still holds the money. */
export const PaymentBadge: React.FC<{ cart: ICart }> = ({ cart }) => {
  if (cart.payment_method !== "CARD") return null;

  const label = LABELS[cart.payment_status ?? ""] ?? { text: cart.payment_status ?? "?", color: "medium" };
  const days = cart.payment_status === "AUTHORIZED" ? daysSinceAuthorization(cart) : null;
  const urgent = days !== null && days >= WARN_FROM_DAY;

  return (
    <IonChip color={urgent ? "danger" : label.color} style={{ margin: 0 }}>
      <IonLabel>
        KARTICA: {label.text}
        {days !== null && ` (dan ${days + 1}/${HOLD_DAYS})`}
      </IonLabel>
    </IonChip>
  );
};
